var cov_1laka4nzz3 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Image/styles/index.ts",
      hash = "e5869e4dc4735d58c0e804953e3246ab36f1d7c5",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Image/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 26
        },
        end: {
          line: 5,
          column: 56
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var imageLess = {};
import genaration from '../../utils/classname';
export var imageClass = (cov_1laka4nzz3.s[0]++, genaration(imageLess, 'image'));